// src/jsx/Layout.jsx
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import JobieNav from "./nav"; // this is the file where JobieNav is declared
import { Outlet } from "react-router-dom";
import { resetMenu } from "../../store/actions/AuthActions";

const Layout = () => {
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);

  console.log("Layout - sideMenu state:", sideMenu);
  console.log(
    "Layout - menu-toggle class will be:",
    sideMenu ? "menu-toggle" : ""
  );

  // Reset menu state when Layout component mounts "change for when user comes first"
  // useEffect(() => { 
  //   console.log("Layout - component mounted, resetting menu state");
  //   dispatch(resetMenu());
  // }, [dispatch]);

  return (
    <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
      <JobieNav />
      <div className="content-body">
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
